import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { SystemDropdownCategory } from "../client-file/api/ClientFileApi";
import { useSystemDropdownOptions } from "./useSystemDropdownOptions";

export function useClientStatusLabel() {
  const { t } = useTranslation();
  const { labelOf } = useSystemDropdownOptions(SystemDropdownCategory.ClientStatus);

  return useCallback(
    (status: string | null | undefined) => labelOf(status) || t("clients.client.emptyStatus"),
    [labelOf, t]
  );
}
